import { Chip } from "@mui/material"
import type { FC } from "react"

interface CostBreakdownCostSourceCellProps {
  isManagedInAs400: boolean
}

export const CostBreakdownCostSourceCell: FC<CostBreakdownCostSourceCellProps> = ({ isManagedInAs400 }) => (
  <Chip
    size='small'
    label={isManagedInAs400 ? "AS400" : "AEROS"}
    className={`h-6 rounded text-xs text-gray-900 ${isManagedInAs400 ? "bg-gray-300" : "bg-primary-200"}`}
    data-testid='cost-breakdown.table.cost-source-chip'
  />
)
